<template>
  <div class="form-dashboard-container">
    <DashboardContainerNavbar title="Dashboard" button dateFilter deviceFilter @search-input="handleFormSearch" />
    <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
    <div v-else class="stats-cards-container">
      <v-empty-state v-if="formList.length === 0" icon="mdi-magnify" :headline="$t('i18n.noForms')" :text="$t('i18n.noFormsText')" title=""></v-empty-state>
      <FormStatsCard v-for="form in filteredOrderedForms" :key="form.id" :form="form" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DashboardContainerNavbar from '../navbars/DashboardContainerNavbar.vue'
import FormStatsCard from '../cards/FormStatsCard.vue'
import { Form, DashboardFilters } from '@/utils/DataTypes'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'
import { api } from '@/utils/HelperFunctions'

export default defineComponent({
  name: 'StatisticsDashboard',
  setup() {
    const router = useRouter()
    const appStore = useAppStore()
    return {
      router,
      appStore
    }
  },
  components: {
    DashboardContainerNavbar,
    FormStatsCard
  },
  async mounted() {
    await this.getFormList()
    this.loading = false
  },
  data() {
    return {
      formList: [] as Form[],
      loading: true
    }
  },
  methods: {
    async getFormList() {
      try {
        const url = '/forms-simplified'
        const getFormListResponse = await api(url, 'get')

        if (!getFormListResponse) return

        this.formList = getFormListResponse.data
      } catch (error) {
        this.appStore.addAlert('error', 'Couldn\'t get forms list.')
      }
    },
    navigate(routeName: string) {
      this.router.push({ name: routeName })
    },
    handleFormSearch(searchQuery: string) {
      const newFilters: DashboardFilters = {
        ...this.appStore.dashboardFilters,
        searchFormQuery: searchQuery
      }
      this.appStore.setDashboardFilters(newFilters)
    }
  },
  computed: {
    filteredOrderedForms(): Form[] {
      const dashboardFilters = this.appStore.getAppState.dashboardFilters
      const searchQueryLower = dashboardFilters.searchFormQuery.toLowerCase()

      const filteredForms = this.formList
        .filter((form: Form) =>
          form.name.toLowerCase().includes(searchQueryLower)
        )
        .sort((a: Form, b: Form) => {
          if (a.id == null && b.id == null) return 0
          if (a.id == null) return 1
          if (b.id == null) return -1
          return b.id - a.id // DESC
        })
      return filteredForms
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.form-dashboard-container {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;

  box-shadow: 2px 0 15px 0 rgba(0, 0, 0, 0.08);

  .stats-cards-container {
    grid-row: 2;
    display: grid;
    gap: 1.0em;
    padding: 1.0em;
    grid-auto-rows: min-content;
    overflow-y: auto;

    .no-data-container {
      display: grid;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
